import { Injectable } from '@angular/core';
import {NodeApiService} from '../../../../services/api/network/online/node/node-api.service';
import {RoutingInterfaceApiService} from '../../../../services/api/network/online/routing-interface/routing-interface-api.service';
import {ConnectionApiService} from '../../../../services/api/network/online/connection/connection-api.service';
import {OperatorsSettingsApiService} from '../../../../services/api/settings/administration/operators/operators-settings-api.service';
import {RoutingServerGroupApiService} from '../../../../services/api/settings/routing-servers/routing-server-groups/routing-server-group-api.service';
import {UserPrivilegeService} from '../../../../services/common/user-privilege/user-privilege.service';
import {LogicalConjunctionService} from '../../../../services/common/logical-conjunction/logical-conjunction.service';
import {NodesDialogService} from '../../../nodes/nodes-dialog/nodes-dialog.service';
import {MapService} from '../../map/map/map.service';

@Injectable({
  providedIn: 'root'
})
export class OnlineNodeService {

  constructor(private nodeApiService: NodeApiService,
              private routingInterfaceApiService: RoutingInterfaceApiService,
              private connectionApiService: ConnectionApiService,
              private routingServerGroupApiService: RoutingServerGroupApiService,
              private operatorApiService: OperatorsSettingsApiService,
              private userPrivilege: UserPrivilegeService,
              private nodesDialogService: NodesDialogService,
              private logicalConjunctionService: LogicalConjunctionService,
              private mapService: MapService) {}

  public lockNode(id: number): void {
    this.nodeApiService.lockNode(id).then(() => {
      this.refreshDiagram();
    }).catch(() => {});
  }

  public unlockNodes(ids: number[]): void {
    this.nodeApiService.unlockNodes(ids).then(() => {
      this.refreshDiagram();
    }).catch(() => {});
  }

  public lockNodes(ids: number[]): void {
    this.nodeApiService.lockNodes(ids).then(() => {
      this.refreshDiagram();
    }).catch(() => {});
  }

  public unlockNode(id: number): void {
    this.nodeApiService.unlockNode(id).then(() => {
      this.refreshDiagram();
    }).catch(() => {});
  }

  public syncNode(id: number): void {
    this.nodeApiService.syncNode(id).then(() => {
      this.refreshDiagram();
    });
  }

  public configureNode(node): void {
    this.nodeApiService.configureNode(node.id).then((value: any) => {
      window.open(value.url);
    }).catch(() => {
      window.open(`${node.transportType.toLowerCase()}://${node.ipAddr}`);
    });
  }

  public deleteNode(node): void {
    this.nodesDialogService.delete(node, () => {
      this.refreshDiagram();
    });

    // const confirmationMessage = `Are you sure you want to delete the node: "${node.name}" ?`;

   /* this.sharedEventService.broadcast('openConfirmationDialogWindow', confirmationMessage, 'Delete', () => {
      this.nodeApiService.deleteNode(node.id).then(() => {
        this.sharedEventService.broadcast('closeConfirmationDialogWindow');
        this.sharedEventService.broadcast('NodesTableRefresh');
        this.refreshDiagram();
      }).catch(() => {
        this.sharedEventService.broadcast('closeConfirmationDialogWindow');
      });
    });*/
  }

  public deleteNodes(nodes): void {
    const ids = nodes.map(node => node.id);
    const confirmationMessage = `Are you sure you want to delete ${ids.length === 1 ?
        `the node: "${nodes[0].name}"` :
        `${ids.length} nodes: ${this.logicalConjunctionService.generateAndDescription(nodes, 'name')}`} ?`;

   /* this.sharedEventService.broadcast('openConfirmationDialogWindow', confirmationMessage, 'Delete', () => {
      this.nodeApiService.deleteNodes(ids).then(() => {
        this.sharedEventService.broadcast('closeConfirmationDialogWindow');
        this.sharedEventService.broadcast('NodesTableRefresh');
        this.refreshDiagram();
      }).catch(() => {});
    });*/
  }

  public editNode(node: any): void {
    this.nodesDialogService.edit(node, () => {
      this.refreshDiagram();
    });

    /*const isAuthorized = this.userPrivilege.isAuthorizedUser();

    Promise.all([this.nodeApiService.getNode(id),
      this.routingServerGroupApiService.getRoutingServerGroups().toPromise(),
      isAuthorized ? this.operatorApiService.getOperators({
        filter: {roles: {
            operator: '=',
            value: ['DEVICE']}
        }}).toPromise() : [],
      isAuthorized ? this.credentialsApiService.getCredentials('DEVICE', {}).toPromise() : []]).then(value => {

      const dataObject = {
        node: value[0],
        routingServerGroups: value[1],
        nodeUsers: value[2],
        nodeCredentials: value[3]
      };

      this.openEditNodeDialog(id, dataObject);
    });*/
  }

  public addNode(node): void {
    this.nodesDialogService.addNode(node, () => {
      this.refreshDiagram();
    }, () => {
      this.removeDraggedSvg();
    });

/*    Promise.all([this.operatorApiService.getOperators({
      filter: {roles: {
          operator: '=',
          value: ['DEVICE']}
      }}).toPromise(),
      this.credentialsApiService.getCredentials('DEVICE', {}).toPromise(),
      this.routingServerGroupApiService.getRoutingServerGroups().toPromise()
    ]).then(value => {
      const dataObject = {
        nodeUsers: value[0],
        nodeCredentials: value[1],
        routingServerGroups: value[2]
      };

      nodeToAdd.isIpAddressProvidedForGUI = true;
      this.openAddNodeDialog(nodeToAdd, dataObject);
    });*/
  }

  public editThirdPartyDevice(node): void {
    this.nodesDialogService.edit(node, () => {
      this.refreshDiagram();
    });
    /*Promise.all([this.nodeApiService.getNode(id),
      this.routingInterfaceApiService.getRoutingInterfacesForMap({filter: {nodeId: id}})]).then(data => {
      const node = data[0];
      node.routingInterfaces = data[1].filter(ri => {
        return ri.udpPort > -1;
      });

      this.openUpdateThirdPartyDeviceDialog(node, id);
    });*/
  }

  public addThirdPartyDevice(node): void {
    this.nodesDialogService.addThirdPartyNode(node, () => {
      this.refreshDiagram();
    }, () => {
      this.removeDraggedSvg();
    });
    // const nodeToAdd = _.cloneDeep(node);
   /* this.sharedEventService.broadcast('openThirdPartyDeviceDialog', nodeToAdd, true, () => {
      this.nodeApiService.addNode(nodeToAdd).then(() => {
        this.sharedEventService.broadcast('closeThirdPartyDeviceDialog');
        this.refreshDiagram();
      }).catch(() => {});
    });*/
  }

  public saveIniFile(node): void {
    this.nodeApiService.getNodeINIFile(node.id);
  }

  private updateAddressProperty(node): void {
    if (node.isIpAddressProvidedForGUI === true) {
      node.ipAddr = node.addressForGUI;
      node.hostname = null;
    } else {
      node.hostname = node.addressForGUI;
      node.ipAddr = null;
    }
  }

  private openUpdateThirdPartyDeviceDialog(node, id: number): void {
   /* this.sharedEventService.broadcast('openThirdPartyDeviceDialog', node, false, () => {
      this.nodeApiService.editNode(node, id).then(() => {
        this.sharedEventService.broadcast('closeThirdPartyDeviceDialog');
        this.refreshDiagram();
      }).catch(() => {});
    });*/
  }

  private openAddNodeDialog(node, dataObject): void {
   /* this.sharedEventService.broadcast('openAddNodeDialog', node, dataObject.nodeUsers, dataObject.nodeCredentials,
      dataObject.routingServerGroups, () => {
      this.updateAddressProperty(node);
      this.nodeApiService.addNode(node).then(() => {
        this.sharedEventService.broadcast('closeAddNodeDialog');
        this.refreshDiagram();
      }).catch(() => {});
    });*/
  }

  private openEditNodeDialog(id: number, dataObject): void {
   /* this.sharedEventService.broadcast('openNodeDialog', dataObject.node, dataObject.routingServerGroups, dataObject.nodeUsers,
      dataObject.nodeCredentials, () => {
      this.nodeApiService.editNode(dataObject.node, id).then(() => {
        this.sharedEventService.broadcast('closeNodeDialog');
        this.sharedEventService.broadcast('NodesTableRefresh');
        this.refreshDiagram();
      }).catch(() => {});
    });*/
  }

  private refreshDiagram(): void {
    // this.sharedEventService.broadcast('PeriodicRefresh');
    this.mapService.refresh();
    this.mapService.removeDraggedSvg();
  }

  private removeDraggedSvg(): void {
    this.mapService.removeDraggedSvg();
  }
}
